import React, { Fragment } from 'react';
import { Link, Routes, Route, useParams } from 'react-router-dom';

import Subjects from './Subjects';
import Templates from './Templates';
import AssessmentTemplates from './AssessmentTemplates';
import Questions from './Questions';
import Categories from './Categories';
import Subject from './Subject';
import Template from './Template';
import AssessmentTemplate from './AssessmentTemplate';
import Question from './Question';
import Category from './Category';
import CategorySubjects from './CategorySubjects';
import TemplateSubjects from './TemplateSubjects';
import SubjectCategories from './SubjectCategories';
import SubjectTemplates from './SubjectTemplates';
import Material from './Material';
import Materials from './Materials';
import Tags from './Tags';
import ThreatAreas from './ThreatAreas';
import ThreatArea from './ThreatArea';

import { observer } from 'mobx-react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { firebaseTabsStylesHook } from '@mui-treasury/styles/tabs';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import ErrorBoundary from '../../hocs/ErrorBoundary';

const SubjectWrapper = () => {
    const { subjectId, languageId } = useParams();
    return (
        <ErrorBoundary>
            <Subject subjectId={subjectId} languageId={languageId} />
        </ErrorBoundary>
    );
};

function Content() {
    const [tabIndex, setTabIndex] = React.useState(null);
    const tabsStyles = firebaseTabsStylesHook.useTabs();
    const tabItemStyles = firebaseTabsStylesHook.useTabItem();

    return (
        <Fragment>
            <AppBar position="static">
                <Tabs
                    classes={tabsStyles}
                    value={tabIndex}
                    onChange={(e, index) => setTabIndex(index)}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab classes={tabItemStyles} label="Subjects" component={Link} to="subjects" />
                    <Tab classes={tabItemStyles} label="Templates" component={Link} to="templates" />
                    <Tab classes={tabItemStyles} label="Assessment Templates" component={Link} to="assessment-templates" />
                    <Tab classes={tabItemStyles} label="Categories" component={Link} to="categories" />
                    <Tab classes={tabItemStyles} label="Questions" component={Link} to="questions" />
                    <Tab classes={tabItemStyles} label="Materials" component={Link} to="materials" />
                    <Tab classes={tabItemStyles} label="Threat Areas" component={Link} to="threatareas" />
                </Tabs>
            </AppBar>

            <Routes>
                {/* index */}
                <Route
                    index
                    element={
                        <Box ml={4}>
                            <KeyboardArrowUpIcon color="primary" />
                            <Typography>Choose a tab</Typography>
                        </Box>
                    }
                />

                {/* Subjects */}
                <Route path="subjects" element={<Subjects />} />
                <Route path="subjects/:subjectId/categories" element={<SubjectCategories />} />
                <Route path="subjects/:subjectId/templates" element={<SubjectTemplates />} />
                {/* две ветки вместо :languageId? */}
                <Route path="subjects/:subjectId" element={<SubjectWrapper />} />
                <Route path="subjects/:subjectId/:languageId" element={<SubjectWrapper />} />

                {/* Questions */}
                <Route path="questions" element={<Questions />} />
                <Route path="questions/create" element={<Question />} />
                <Route path="questions/:questionId/edit" element={<Question />} />

                {/* Categories */}
                <Route path="categories" element={<Categories />} />
                <Route path="categories/:categoryId" element={<Category />} />
                <Route path="categories/:categoryId/subjects" element={<CategorySubjects />} />

                {/* Templates */}
                <Route path="templates" element={<Templates />} />
                <Route path="templates/:templateId" element={<Template />} />
                <Route path="templates/:templateId/subjects" element={<TemplateSubjects />} />

                {/* Assessment Templates */}
                <Route path="assessment-templates" element={<AssessmentTemplates />} />
                <Route path="assessment-templates/:templateId" element={<AssessmentTemplate />} />

                {/* Materials */}
                <Route path="materials" element={<Materials />} />
                <Route path="materials/create" element={<Material />} />
                <Route path="materials/:materialId/edit" element={<Material />} />

                {/* Tags */}
                <Route path="tags" element={<Tags />} />

                {/* Threat Areas */}
                <Route path="threatareas" element={<ThreatAreas />} />
                <Route path="threatareas/create" element={<ThreatArea />} />
                <Route path="threatareas/:id/edit" element={<ThreatArea />} />
            </Routes>
        </Fragment>
    );
}

export default observer(Content);
